<div class="grid-y grid-frame" [class.minTablet]="layout == 'WorkflowBuilderComponent'" [ngStyle]="{'opacity': (blackoutStage) ? 0 : 1 }">
  <button (click)="skipToMain()" class="skipLink" aria-label="Skip to main content">Skip to Main Content Link</button>
  <app-header></app-header>
  <section aria-label="Sub Heading">
    <sub-header></sub-header>
  </section>
  <side-panel></side-panel>
  <main class="cell auto" [class.relative]="layout == 'FlowComponent'" #main tabindex="-1">
    <!-- using NgClass is causing change detection error, would like to revisit this after demo -->
    <div id="scroll-head" class="cell cell-block-y" #scrollHead [class.paymentProcessing]="layout == 'PaymentProcessingComponent'" [class.flowComponent]="layout == 'FlowComponent'" [class.workflowBuilderComponent]="layout == 'WorkflowBuilderComponent'" [class.stateBuilderComponent]="layout == 'StateBuilderComponent'" [class.cheifsOrders]="layout == 'ChiefsOrders'">
      <router-outlet></router-outlet>
    </div>
  </main>
  <app-footer></app-footer>
  <symbol-defs aria-hidden="true" aria-label="Icon Definitions"></symbol-defs>
  <alert></alert>
  <loader></loader>
  <dynamic-dialog></dynamic-dialog>
    

</div>
